/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfLab } from '../../models/data-page-of-lab';

export interface LabsGetAllLabs$Params {
  emrpracticeId?: string | null;
  patientId?: string | null;
}

export function labsGetAllLabs(http: HttpClient, rootUrl: string, params?: LabsGetAllLabs$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfLab>> {
  const rb = new RequestBuilder(rootUrl, labsGetAllLabs.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('patientId', params.patientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfLab>;
    })
  );
}

labsGetAllLabs.PATH = '/api/Labs/getAllTests';
